// extracted by mini-css-extract-plugin
export default {"FolderPath":"FolderName_FolderPath__9rUai","FolderName":"FolderName_FolderName__jqcPb"};